import { usageId } from "../../constants/usageid.js";
import { UserSchemaIds, UserTags } from "../../schemas/user.const.js";
export const dictionary = {
    form: {
        [usageId(UserSchemaIds.CREATE_MEMBER, UserTags.DEFAULT)]: {
            title: 'Register',
            description: 'Register for access to more restricted atlases.',
            abbr: 'Register',
            cti: 'Please specify your details.',
            properties: {
                email: {
                    title: 'Your e-mail',
                    description: 'The e-mail used for signing in.',
                    abbr: 'E-mail',
                    cti: 'Please specify your e-mail address.',
                },
                secret: {
                    title: 'Your password',
                    description: 'The password known only to you.',
                    abbr: 'Secret',
                    cti: 'Please specify your password.',
                },
                retypeSecret: {
                    title: 'Re-type password',
                    description: 'The confirmation of chosen password.',
                    abbr: 'Re-type password',
                    cti: 'Please re-type your password.',
                },
                locale: {
                    title: 'Your preferred language',
                    description: 'Your preferred language to use when displaying texts and data.',
                    abbr: 'Language',
                    cti: 'Please select your preferred language.',
                }
            }
        },
        [usageId(UserSchemaIds.USER_PROFILE, UserTags.DEFAULT)]: {
            title: 'Your Profile',
            description: 'Your personal settings.',
            abbr: 'Profile',
            cti: 'Please update your settings here.',
            properties: {
                title: {
                    title: 'Your preferred display name',
                    description: 'Your preferred display name.',
                    abbr: 'Title',
                    cti: 'Please specify your preferred display name.',
                },
                locale: {
                    title: 'Your preferred language',
                    description: 'Your preferred language to use when displaying texts and data.',
                    abbr: 'Language',
                    cti: 'Please select your preferred language.',
                }
            }
        },
        [usageId(UserSchemaIds.MEMBER_PROFILE, UserTags.DEFAULT)]: {
            title: 'Your Profile',
            description: 'Your personal settings.',
            abbr: 'Profile',
            cti: 'Please update your settings here.',
            properties: {
                locale: {
                    title: 'Your preferred language',
                    description: 'Your preferred language to use when displaying texts and data.',
                    abbr: 'Language',
                    cti: 'Please select your preferred language.',
                }
            }
        },
    },
};
